import React from 'react'
import moment from 'moment'
import { useValue } from '@morningtrain/react-resources'

export default function BackgroundDays () {
  const modelPeriod = useValue('period')

  const period = {
    from: modelPeriod && modelPeriod.from ? moment(modelPeriod.from) : moment().startOf('isoWeek'),
    to: modelPeriod && modelPeriod.to ? moment(modelPeriod.to) : moment().add(1, 'year')
  }

  let currentDay = period.from.startOf('isoWeek')
  let to = period.to.endOf('isoWeek')

  const days = []

  while (currentDay <= to) {
    days.push(currentDay.clone())
    currentDay.add(1, 'day')
  }

  // const width = 30 * days.length * 1.2

  const today = moment().format('YYYY-MM-DD')

  return (
    <>
      {days.map(day => {
        const classList = [
          'day',
          day.format('YYYY-MM-DD') === today ? 'today' : ''
        ]

        return (
          <div key={day.format('YYYY-MM-DD')} className={classList.join(' ')}/>
        )
      })}
    </>
  )
}
